import ArticleList from "../../../components/admin/articles/ArticleList";
import Admin from "../../Admin";

const Article = () => {
    return ( 
        <Admin>
            <ArticleList/>
        </Admin>
     );
}
 
export default Article;